import React from 'react';
import { useTranslation } from 'react-i18next';
import { transparentize } from 'polished';
import { Headline, BodyText } from '@keen.io/typography';
import { Button } from '@keen.io/ui-core';
import { colors } from '@keen.io/colors';
import { Container, Header } from './SectionTitle.styles';

var SectionTitle = function SectionTitle(_ref) {
  var title = _ref.title,
      description = _ref.description,
      onClear = _ref.onClear;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return React.createElement(Container, null, React.createElement(Header, null, React.createElement(Headline, {
    variant: "h4"
  }, title), onClear && React.createElement(Button, {
    size: "small",
    style: "outline",
    variant: "secondary",
    onClick: onClear
  }, t('widget_customization_section.clear_button'))), description && React.createElement(BodyText, {
    variant: "body2",
    color: transparentize(0.5, colors.black[100])
  }, description));
};

export default SectionTitle;